var source_tracking = {

    settings: {
        cookie_name: 'pc_paid_source',
        cookie_days: 7,
        params: ['utm_source', 'utm_medium', 'utm_campaign'],
    },

    init: function () {
        source_tracking.recordPaidVisit();
    },

    // Records any visit whose URL carries a utm_source; includes/tracking.php
    // decides on form submission whether that source counts as paid. Each one
    // overwrites the cookie and restarts its expiry, so the most recent visit
    // is the one credited.
    recordPaidVisit: function () {
        var query = new URLSearchParams(window.location.search);
        var visit = {};

        source_tracking.settings.params.forEach(function (param) {
            visit[param] = (query.get(param) || '').trim().slice(0, 100);
        });

        if (!visit.utm_source) {
            return;
        }

        document.cookie = source_tracking.settings.cookie_name + '=' + encodeURIComponent(JSON.stringify(visit))
            + '; max-age=' + (source_tracking.settings.cookie_days * 86400)
            + '; path=/; SameSite=Lax'
            + (window.location.protocol === 'https:' ? '; Secure' : '');
    },

}
source_tracking.init();
